import { useEffect, useState } from 'react';
import {
  Card,
  Input,
  Button,
  Form,
  Col,
  message,
  Spin,
  Select,
  Modal
} from 'antd';
import { headerStyle } from 'shared/styles/baseStyle';
import useHttpClient from 'shared/hooks/http-hook';
import EndPoints from 'shared/endPoints/EndPoints.json';

export default function Message() {
  const { Option } = Select;
  const { TextArea } = Input;
  const regex = /^https:\/\/.+/i;
  const [form] = Form.useForm();
  const { responseData, sendRequest, status, requestIdentifier, loading } =
    useHttpClient();
  const [disablePostButton, setDisablePostButton] = useState(false);
  const [messageValue, setMessageValue] = useState('scrolling');
  const submitButtonTitle = !disablePostButton
    ? 'Αποστολή Μηνύματος'
    : 'Διαγραφή Μηνύματος';

  const submitButton = () => (
    <Button htmlType="submit">{submitButtonTitle}</Button>
  );

  const messageOptions = [
    {
      key: 'scrolling',
      name: 'Κυλιόμενο μήνυμα'
    },
    {
      key: 'push',
      name: 'Push Ειδοποίηση'
    }
  ];

  useEffect(() => {
    sendRequest(
      {
        endpoint: EndPoints.NOTIFICATION.NOTIFICATION,
        method: 'GET'
      },
      `GETNOTIFICATION`
    );
  }, []);

  useEffect(() => {
    if (requestIdentifier === 'SENDPUSHNOTIFICATION' && status === 'resolved') {
      message.success(
        'Η αποστολή της ειδοποίησης πραγματοποιήθηκε με επιτυχία'
      );
      form.resetFields(['title', 'body', 'url']);
    }
  }, [status, responseData, requestIdentifier]);

  const onFinish = values => {
    if (disablePostButton) {
      sendRequest(
        {
          endpoint: EndPoints.NOTIFICATION.NOTIFICATION,
          method: 'DELETE',
          data: {}
        },
        'DELETENOTIFICATION',
        'Η Εισαγωγή Μηνύματος πραγματοποίθηκε με επιτυχία'
      );
      return;
    }
    if (values?.description) {
      sendRequest(
        {
          endpoint: EndPoints.NOTIFICATION.NOTIFICATION,
          method: 'POST',
          data: { description: values?.description }
        },
        'POSTNOTIFICATION',
        'Η Εισαγωγή Μηνύματος πραγματοποίθηκε με επιτυχία'
      );
      return;
    }
    if (values.messageOption === 'push') {
      if (values.url && !regex.test(values.url)) {
        message.error('Πρέπει να είναι κενό ή URL που ξεκινάει με https://');
        return;
      }
      Modal.confirm({
        title: 'Επιβεβαίωση Αποστολής',
        content:
          'Είστε σίγουρος/η ότι θέλετε να στείλετε ειδοποίηση σε όλους τους χρήστες με ενεργά συμβόλαια;',
        okText: 'Ναι',
        cancelText: 'Ακύρωση',
        onOk() {
          sendRequest(
            {
              endpoint: `${EndPoints.PUSHNOTIFICATION.PUSHNOTIFICATION}`,
              method: 'POST',
              data: {
                title: values.title,
                body: values.body,
                url: values.url
              }
            },
            'SENDPUSHNOTIFICATION'
          );
        }
      });
      return;
    }
    message.info('Παρακαλώ Συμπληρώστε ένα μήνυμα');
  };

  useEffect(() => {
    if (status === 'resolved' && requestIdentifier === 'POSTNOTIFICATION') {
      message.success('Η Εισαγωγή Μηνύματος πραγματοποίθηκε με επιτυχία');
      setDisablePostButton(true);
    }
    if (status === 'resolved' && requestIdentifier === 'DELETENOTIFICATION') {
      message.success('Η Διαγραφή Μηνύματος πραγματοποίθηκε με επιτυχία');
      form.resetFields();
      setDisablePostButton(false);
    }
    if (
      status === 'resolved' &&
      requestIdentifier === 'GETNOTIFICATION' &&
      responseData
    ) {
      form.setFieldValue('description', responseData?.description);
      setDisablePostButton(true);
    }
  }, [form, requestIdentifier, status, responseData]);

  const handleChange = value => {
    setMessageValue(value);
  };
  return (
    <Card
      type="inner"
      headStyle={headerStyle}
      title="Μήνυμα"
      style={{ textAlign: 'center' }}
    >
      <Form onFinish={onFinish} form={form}>
        {loading ? (
          <Spin size="large" />
        ) : (
          <>
            <Col span={8} offset={6}>
              <Form.Item name="messageOption" label="Επίλεξε Είδος Μηνύματος">
                <Select onChange={handleChange} defaultValue="scrolling">
                  {messageOptions.map(option => (
                    <Option key={option.key} value={option.key}>
                      {option.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {messageValue === 'scrolling' && (
              <Col span={12} offset={6}>
                <Form.Item name="description">
                  <TextArea
                    rows={4}
                    disabled={disablePostButton}
                    maxLength={150}
                    style={{ resize: 'none' }}
                  />
                </Form.Item>
              </Col>
            )}
            {messageValue === 'push' && (
              <Col span={12} offset={6}>
                <Form.Item name="title">
                  <TextArea
                    placeholder="Τίτλος"
                    rows={1}
                    disabled={disablePostButton}
                    style={{ resize: 'none' }}
                  />
                </Form.Item>
                <Form.Item name="body">
                  <TextArea
                    placeholder="Μήνυμα"
                    rows={20}
                    disabled={disablePostButton}
                    style={{ resize: 'none' }}
                  />
                </Form.Item>
                <Form.Item name="url">
                  <TextArea rows={2} placeholder="url" />
                </Form.Item>
              </Col>
            )}
            <Form.Item>{submitButton()}</Form.Item>
          </>
        )}
      </Form>
    </Card>
  );
}
